// Auto-generated by Storyline Creator (Vite)

export default {
  "id": "a_friendly_weapon",
  "title": "A Friendly Weapon",
  "coverImage": "",
  "requirements": [
    {
      "type": "flag",
      "key": "resturn_home",
      "eq": true
    }
  ],
  "startScene": "start",
  "scenes": {
    "start": {
      "steps": [
        {
          "type": "page",
          "image": "images\\a_friendly_weapon_1.png",
          "text": "Click to continue."
        },
        {
          "type": "ending",
          "image": "images\\a_friendly_weapon_2.png",
          "text": "Click to fight!",
          "effects": [
            {
              "type": "startCombat",
              "encounterId": "nested_horror",
              "resumeStorylet": "__current__",
              "resumeScene": "scene_1"
            },
            {
              "type": "addCardToDeck",
              "id": "69d8b1e9c2fd5408ce9a9f46",
              "copies": 1,
              "destination": "deckTop"
            }
          ]
        }
      ]
    },
    "scene_1": {
      "steps": [
        {
          "type": "page",
          "image": "images\\a_friendly_weapon_3.png",
          "text": "Click to continue."
        },
        {
          "type": "ending",
          "image": "image\\a_friendly_weapon_4.png",
          "text": "Click to continue.",
          "effects": []
        },
        {
          "type": "ending",
          "image": "image\\a_friendly_weapon_5.png",
          "text": "Click to end the storyline.",
          "effects": [
            {
              "type": "sanity",
              "delta": 100
            }
          ]
        }
      ]
    },
    "end": {
      "steps": [
        {
          "type": "ending",
          "effects": []
        }
      ]
    }
  }
};
